import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG, AppConfig } from "app.config";
import { Observable } from "rxjs";
import {
  FeatureInsightResponse,
  FeatureTrendResponse,
} from "../models/feature-insight.model";
import {
  GetFeatureInsightParams,
  GetFeatureTrendParams,
} from "../models/http-request.model";
import { HttpService } from "./http.service";

@Injectable({ providedIn: "root" })
export class InsightHttpService {
  private resource: string;

  constructor(
    private http: HttpService,
    @Inject(APP_CONFIG)
    private config: AppConfig
  ) {
    this.resource = this.config.apiHost;
  }

  public getFeatureInsight(
    params: GetFeatureInsightParams
  ): Observable<FeatureInsightResponse> {
    return this.http.get<FeatureInsightResponse>(
      `${this.resource}/admin/insights/features`,
      params
    );
  }

  public getFeatureTrend(
    params: GetFeatureTrendParams
  ): Observable<FeatureTrendResponse> {
    return this.http.get<FeatureTrendResponse>(
      `${this.resource}/admin/insights/features/trend`,
      params
    );
  }
}
